import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import WhoAreWePage from "./pages/WhoAreWePage";
import NotFoundPage from "./pages/NotFoundPage";
import AssociationRegistrationCertificate from "./pages/AssociationRegistrationCertificate";
import CommercialRegistration from "./pages/CommercialRegistration";
import BoardOfDirectors from "./pages/BoardOfDirectors";
import Founding from "./pages/Founding";
import OrganizationStructore from "./pages/OrganizationStructore";
import StrategicMap from "./pages/StrategicMap";
import OperationalPlan from "./pages/OperationalPlan";
import MemberOfGeneralAssembly from "./pages/MemberOfGeneralAssembly";
import ManagerialPosition from "./pages/ManagerialPosition";
import Commission from "./pages/Commission";
import Branches from "./pages/Branches";
import FinancialSustainabilityAndSupportingProjects from "./pages/FinancialSustainabilityAndSupportingProjects";
import AgmFilesJune2024 from "./pages/AgmFilesJune2024";
import OrdinaryGeneralAssemblyFilesOctober2024 from "./pages/OrdinaryGeneralAssemblyFilesOctober2024";
import BeneficiaryRegistration from "./pages/BeneficiaryRegistration";
import RequestSubsidiary from "./pages/RequestSubsidiary";
import MemberAccounts from "./pages/MemberAccounts";
import TransparencyBoardCandidates from "./pages/TransparencyBoardCandidates";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import GovernanceGuides from "./pages/GovernanceGuides";
import AssociationByLawsAndPolicies from "./pages/AssociationByLawsAndPolicies";
import AnnualReport from "./pages/AnnualReport";
import CertificatesAndAccreditations from "./pages/CertificatesAndAccreditations";
import FinancialStatement from "./pages/FinancialStatement";
import AssociationRegulationAndPolicies from "./pages/AssociationRegulationAndPolicies";
import BoardOfDirectorsReport from "./pages/BoardOfDirectorsReport";
import MeasuringBeneficiarySatisfaction from "./pages/MeasuringBeneficiarySatisfaction";
import HomepageLayout from "./layout/HomepageLayout";
import StaffAndVolunteerSatisfactionSurvey from "./pages/StaffAndVolunteerSatisfactionSurvey";
import News from "./pages/News";
import SingleNews from "./pages/SingleNews";
import AboutTheAssociationVision from "./pages/AboutTheAssociationVision";
import AboutTheAssociationMessage from "./pages/AboutTheAssociationMessage";
import AboutTheAssociationOrganizationalStructure from "./pages/AboutTheAssociationOrganizationalStructure";
import Employment from "./pages/Employment";
const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* GOVERNANCE MODULE  */}
        <Route
          path="/certificates_and_accreditations"
          element={<CertificatesAndAccreditations />}
        />
        <Route path="/financial_statements" element={<FinancialStatement />} />
        <Route
          path="/association_regulation_and_policies"
          element={<AssociationRegulationAndPolicies />}
        />
        <Route
          path="/board_of_directors_reports"
          element={<BoardOfDirectorsReport />}
        />
        <Route
          path="/transparency_board_candidates"
          element={<TransparencyBoardCandidates />}
        />
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        <Route path="/governance_guides" element={<GovernanceGuides />} />
        <Route
          path="/association_by_laws_policies"
          element={<AssociationByLawsAndPolicies />}
        />
        <Route path="/annual_reports" element={<AnnualReport />} />
        {/* end GOVERNANCE MODULE  */}
        <Route path="/about" element={<AboutPage />} />
        {/* ABOUT MODULE */}
        <Route path="/who_are_we" element={<WhoAreWePage />} />
        <Route
          path="/association_registration_certificate"
          element={<AssociationRegistrationCertificate />}
        />
        <Route path="/board_of_directors" element={<BoardOfDirectors />} />
        <Route path="/founding" element={<Founding />} />
        <Route
          path="/organizational_structure"
          element={<OrganizationStructore />}
        />
        <Route path="/strategic_map" element={<StrategicMap />} />
        <Route path="/operational_plan" element={<OperationalPlan />} />
        <Route path="/general_assembly" element={<MemberOfGeneralAssembly />} />
        <Route path="/managerial_position" element={<ManagerialPosition />} />
        <Route path="/commision" element={<Commission />} />
        <Route path="/branches" element={<Branches />} />
        <Route
          path="/financial_sustainability_and_supporting_projects"
          element={<FinancialSustainabilityAndSupportingProjects />}
        />
        {/* END OF ABOUT MODULE */}
        {/* GENERAL ASSEMBLY MODULE */}
        <Route path="/agm_files_june_2024" element={<AgmFilesJune2024 />} />
        <Route
          path="/ordinary_general_assembly_files_october_2024"
          element={<OrdinaryGeneralAssemblyFilesOctober2024 />}
        />
        {/* END OF GENERAL ASSEMBLY MODULE */}
        {/* BENEFICIARY SERVICES */}
        <Route
          path="/beneficiary_registration"
          element={<BeneficiaryRegistration />}
        />
        <Route path="/request_subsidiary" element={<RequestSubsidiary />} />
        <Route path="/preview_patron_file" element={<MemberAccounts />} />
        <Route
          path="/update_beneficiary_details"
          element={<MemberAccounts />}
        />
        <Route path="/my_vouchers" element={<MemberAccounts />} />
        {/* END OF BENEFICIARY SERVICES */}
        {/* VISITOR SERVICES */}
        <Route path="/register_my_donations" element={<MemberAccounts />} />
        <Route path="/kafalati" element={<MemberAccounts />} />
        <Route
          path="/my_volunteer_opportunities"
          element={<MemberAccounts />}
        />
        <Route path="/programs" element={<MemberAccounts />} />
        <Route path="/tributary" element={<MemberAccounts />} />
        <Route
          path="/general_assembly_member_account"
          element={<MemberAccounts />}
        />
        {/* END OF VISITOR SERVICES */}

        {/* MEDIA CENTER */}

        <Route path="/" element={<HomepageLayout />}>
          <Route index element={<Homepage />} />

          {/* ABOUT THE ASSOCIATION */}
          <Route path="about_the_association">
            <Route path="vision" element={<AboutTheAssociationVision />} />
            <Route path="message" element={<AboutTheAssociationMessage />} />
            <Route
              path="commercial_registration"
              element={<CommercialRegistration />}
            />
            <Route
              path="organizational_structure"
              element={<AboutTheAssociationOrganizationalStructure />}
            />
          </Route>

          {/* CONTACT */}
          <Route path="/contact" element={<ContactPage />} />

          {/* MEDIA CENTER */}
          <Route
            path="/media_center/measuring_beneficiary_satisfaction"
            element={<MeasuringBeneficiarySatisfaction />}
          />
          <Route
            path="/media_center/staff_and_volunteer_satisfaction_survey"
            element={<StaffAndVolunteerSatisfactionSurvey />}
          />
          {/* NEWS */}
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<SingleNews />} />

          {/* EMPLOYMENT */}
          <Route path="/employment" element={<Employment />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
